import { Routes, Route } from 'react-router-dom';
import { useIntl } from 'react-intl';
import RouteWrapper from '../common/RouteWrapper';
import RedirectToApp from './RedirectToApp';
import AppErrorRoute from './Error';
import ChromeAdblockRoute from './ChromeAdblock';
import OneTimeCodeRedirect from './OneTimeCodeRedirect';

const RedirectRoutes = () => {
  const intl = useIntl();

  return (
    <Routes>
      {/* this one builds App link from query params */}
      <Route
        path="redirect-to-app"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'toApp.seo.title',
              defaultMessage: 'ClearVPN | Open App',
              description: "SEO title of the page that opens ClearVPN app on user's device",
            })}
          >
            <RedirectToApp
              title={intl.formatMessage({
                id: 'redirectToApp.title',
                defaultMessage: "You're successfully logged in!",
                description:
                  'Title of the page, that brings the user back into App, after completing login flow in browser',
              })}
            />
          </RouteWrapper>
        }
      />

      {/* and this one has a static clearvpn:// */}
      <Route
        path="to-app"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'toApp.seo.title',
              defaultMessage: 'ClearVPN | Open App',
              description: "SEO title of the page that opens ClearVPN app on user's device",
            })}
          >
            <RedirectToApp
              title={intl.formatMessage({
                id: 'toApp.title',
                defaultMessage: 'Open ClearVPN app',
                description: 'Title of the page, that opens up a predefined screen of the app',
              })}
            />
          </RouteWrapper>
        }
      />

      <Route
        path="to-chrome"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'toChromeExtension.seo.title',
              defaultMessage: 'ClearVPN | Open Chrome Extension',
            })}
          >
            <ChromeAdblockRoute />
          </RouteWrapper>
        }
      />

      <Route
        path="otc"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'otcProxyPage.seo.title',
              defaultMessage: 'ClearVPN | One time code',
              description: "SEO title of the page that opens ClearVPN app on user's device",
            })}
          >
            <OneTimeCodeRedirect />
          </RouteWrapper>
        }
      />

      <Route
        path="error"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'appError.seo.title',
              defaultMessage: 'ClearVPN | Something is wrong',
            })}
          >
            <AppErrorRoute />
          </RouteWrapper>
        }
      />
    </Routes>
  );
};

export default RedirectRoutes;
